package com.siriusxm.pia.views.unifiedaggregator.batch

import androidx.compose.runtime.*
import com.siriusxm.cmc.error
import com.siriusxm.pia.components.*
import com.siriusxm.pia.views.unifiedaggregator.AggregatorService
import com.siriusxm.pia.views.unifiedaggregator.typeSelect
import unifiedcontent.aggregator.BatchDescriptor
import unifiedcontent.aggregator.BatchingRequest
import unifiedcontent.aggregator.EntityTypeConfiguration
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonArray
import kotlinx.serialization.json.buildJsonObject
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text

val ENTITY_FILTER = "com.siriusxm.unifiedcontent.batch.EntityFilter"

@Composable
fun ServiceViewContext.batchJob(aggregator: AggregatorService) {
    var batchJobs by remember { mutableStateOf<List<BatchDescriptor>?>(null) }
    var selectedJob by remember { mutableStateOf<BatchDescriptor?>(null) }

    LaunchedEffect(true) {
        try {
            val jobs = aggregator.clientApi.getBatchJobs()
            batchJobs = jobs
            selectedJob = jobs.firstOrNull()
        } catch (t: Throwable) {
            aggregator.notifications.error("The operation could not be completed", t.message)

        }
    }

    var selectedTypes by remember { mutableStateOf<Collection<EntityTypeConfiguration>>(emptyList()) }

    serviceContentView {
        waitUntilNonNull(batchJobs) {
            dialogView("Start a batch job") {
                content {
                    dialogField("Job Type") {
                        Select({
                            onChange { update ->
                                selectedJob = batchJobs?.find { it.jobType == update.value }
                            }
                        }) {
                            batchJobs?.forEach {
                                Option(it.jobType, {
                                    if (selectedJob?.jobType == it.jobType) {
                                        selected()
                                    }
                                }) {
                                    Text(it.jobType)
                                }
                            }
                        }
                    }

                    selectedJob?.let { descriptor ->
                        if (descriptor.parameterType == ENTITY_FILTER) {
                            dialogField("types") {
                                aggregator.typeSelect(selectedTypes) {
                                    selectedTypes = it
                                }
                            }
                        }
                    }
                }
                if (selectedTypes.isNotEmpty()) {
                    action("Submit", true) {
                        if (selectedTypes.isNotEmpty()) {
                            aggregator.clientApi.startBatchJob(
                                BatchingRequest(
                                    jobType = selectedJob!!.jobType,
                                    parameters = buildJsonObject {
                                    put("types", buildJsonArray {
                                        selectedTypes.forEach {
                                            add(JsonPrimitive(it.type))
                                        }
                                    })
                                }
                            ))
                        }
                    }
                }
            }
        }
    }
}